/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WindowsResponseGetRecordsList } from '../../models/windows-response-get-records-list';

export interface BuildingsControllerWindows$Params {

/**
 * ISO standard Alpha-2 country code.The building address country code.
 */
  countryCode: 'AT' | 'BE' | 'CH' | 'CZ' | 'DE' | 'ES' | 'FR' | 'NL' | 'PL' | 'SK';

/**
 * The year when the construction or renovation of the windows was made.
 */
  windowsConstructionYear: number;
}

export function buildingsControllerWindows(http: HttpClient, rootUrl: string, params: BuildingsControllerWindows$Params, context?: HttpContext): Observable<StrictHttpResponse<WindowsResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, buildingsControllerWindows.PATH, 'get');
  if (params) {
    rb.query('countryCode', params.countryCode, {});
    rb.query('windowsConstructionYear', params.windowsConstructionYear, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WindowsResponseGetRecordsList>;
    })
  );
}

buildingsControllerWindows.PATH = '/planning-projects/v1-preview/buildings/windows';
